import { render, staticRenderFns } from "./servicios-form.vue?vue&type=template&id=4798079c&scoped=true"
import script from "./servicios-form.vue?vue&type=script&lang=js"
export * from "./servicios-form.vue?vue&type=script&lang=js"
import style0 from "./servicios-form.vue?vue&type=style&index=0&id=4798079c&prod&scoped=true&lang=css"
import style1 from "./servicios-form.vue?vue&type=style&index=1&id=4798079c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798079c",
  null
  
)

export default component.exports